import React, { Fragment, Component } from "react"
import PropTypes from "prop-types"

export default class LazyLoader extends Component {
    static propTypes = {
        getModule: PropTypes.func.isRequired,
    }

    state = { isLoaded: false }
    componentWillMount() {
        this.props
            .getModule()
            .then(Component => {
                this.Component = Component
                this.setState({ isLoaded: true })
            })
            .catch(() => {
                this.setState({ hasError: true })
            })
    }

    render() {
        if (this.state.hasError)
            return (
                "an error occured while loading a dependency (" +
                this.props.module +
                "." +
                this.props.name +
                ")"
            )
        if (!this.state.isLoaded) return null

        return this.props.children(this.Component)
    }
}



// WEBPACK FOOTER //
// ./src/utils/LazyLoading.js